import { render, staticRenderFns } from "./DettagliIntermediario.vue?vue&type=template&id=5a0ef5ea&scoped=true&"
import script from "./DettagliIntermediario.vue?vue&type=script&lang=js&"
export * from "./DettagliIntermediario.vue?vue&type=script&lang=js&"
import style0 from "./DettagliIntermediario.vue?vue&type=style&index=0&id=5a0ef5ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0ef5ea",
  null
  
)

export default component.exports